var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthgoal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_84_3626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0608 29.1872C53.1546 30.2028 52.6546 30.8902 51.6234 30.984C48.0925 31.2965 44.124 30.7496 40.5462 30.984C39.64 30.8746 39.0776 30.0778 39.1869 29.1872C37.9839 29.281 36.5778 29.0623 35.406 29.1872C34.2342 29.3122 33.953 29.8122 33.6874 30.5153C33.4061 34.5774 33.6561 38.7021 33.5624 42.7955C33.4218 43.7173 32.125 43.7329 32 42.7174V30.859C32.1875 29.1404 33.5936 27.7655 35.3122 27.6249C37.0308 27.4843 37.9214 27.703 39.1713 27.6249C39.1244 26.8437 39.6088 26.1406 40.39 26H51.7797C52.639 26.0937 53.1389 26.7968 53.0608 27.6249C55.3106 27.7811 58.1854 26.9531 59.6384 29.1872C59.779 29.406 60.2321 30.3278 60.2321 30.5465V42.983C61.2477 42.3424 62.4194 41.9675 63.6225 41.8893C64.8255 41.8112 65.6535 41.6862 65.6223 42.7799C65.591 43.8736 64.7474 45.9359 64.0131 46.9514C63.2787 47.967 63.56 47.2952 63.5912 47.5764C64.7005 47.8889 65.6848 48.6857 66.4035 49.5762C69.9344 54.0134 68.6221 63.5907 62.81 65.5593C61.2633 66.0905 57.4667 66.0437 55.7481 65.9187C54.0295 65.7937 51.6547 64.4188 50.3579 62.5752C50.2173 62.3721 49.9048 61.7003 49.7329 61.6378H35.0779C33.4061 61.3878 32.1875 60.0441 32 58.388V48.795C32.2812 47.8732 33.3593 47.9201 33.5624 48.8732V58.3724C33.5624 58.9817 34.4998 60.0754 35.0779 60.0754H49.1549C47.6237 55.4351 48.6705 48.3888 54.3107 47.2795C53.967 46.639 53.2483 44.936 53.6233 44.2798C53.9514 43.7017 55.3106 43.9204 55.8575 44.0454C56.8105 44.2485 57.6229 44.7329 58.2479 45.4828L58.6541 44.7172V30.859C58.6385 30.1715 57.6542 29.1716 56.998 29.1716H53.0608V29.1872ZM51.4984 27.5468H40.7337V29.4216H51.4984V27.5468ZM63.9037 43.4673C61.5132 43.4673 59.6384 45.0766 59.2947 47.4514C59.7165 47.3733 60.154 47.2795 60.5758 47.217C61.4351 47.0921 61.4351 47.2639 62.1695 46.639C62.9038 46.014 63.6068 44.6391 63.8881 43.483L63.9037 43.4673ZM57.5136 47.4358C57.2011 46.4046 56.3574 45.5922 55.2481 45.5609C55.4356 46.0765 55.92 47.1077 56.4824 47.2639C57.0449 47.4202 57.2011 47.3108 57.5136 47.4358ZM54.7638 48.795C48.2487 49.5294 48.7174 62.9814 55.17 64.2626C56.4355 64.5125 60.6071 64.5125 61.857 64.2313C68.5439 62.7158 68.9658 47.3108 60.0134 48.8888C59.6072 48.9669 58.7322 49.3263 58.4198 49.3106C58.1073 49.295 57.6073 49.045 57.2636 48.9825C56.4199 48.8107 55.6231 48.7013 54.7638 48.795Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9533 47.1543C47.2653 46.5762 48.6246 55.9348 42.5157 57.216C35.4381 58.7002 33.907 47.7949 40.9533 47.1543ZM41.1095 48.7167C36.5162 49.1073 37.063 56.0754 41.6251 55.7942C46.1872 55.513 45.7967 48.3104 41.1095 48.7167Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5163 35.2808H55.6867C56.7023 35.6089 56.3273 36.8744 55.2961 36.8276H38.0475C37.0476 36.8901 36.5945 35.7495 37.5163 35.2808Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2522 39.5148C37.3772 39.4054 37.6428 39.3273 37.8146 39.3273L52.4228 39.3898C53.1572 39.8585 52.9228 40.8584 52.0166 40.8896H37.8146C37.1272 40.8584 36.7366 39.9835 37.2522 39.5148Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5906 43.4052H49.9021C50.777 43.4833 50.902 44.4988 50.1521 44.8894L37.8093 44.9519C36.9032 44.8582 36.7157 43.7489 37.5906 43.4052Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6102 45.045C33.8132 44.8106 33.907 46.7011 32.6727 46.5917C31.8446 46.5136 31.7822 45.2012 32.6102 45.045Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4991 27.5472H40.7344V29.422H51.4991V27.5472Z",
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.902 43.4675C63.6207 44.6236 63.1052 45.8423 62.1834 46.6235C61.2616 47.4046 61.4334 47.0922 60.5897 47.2015C60.1523 47.264 59.7304 47.3578 59.3086 47.4359C59.6523 45.0611 61.5272 43.4675 63.9176 43.4518L63.902 43.4675Z",
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5115 47.4361C57.1991 47.3111 56.7772 47.3423 56.4804 47.2642C55.9179 47.108 55.4336 46.0768 55.2461 45.5612C56.3554 45.5925 57.1991 46.3893 57.5115 47.4361Z",
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1085 48.7168C45.7957 48.3106 46.2956 55.4975 41.6241 55.7943C36.9526 56.0912 36.5151 49.1074 41.1085 48.7168ZM42.749 50.3417C42.2959 50.451 41.2491 51.904 40.8585 52.279C40.1555 51.2166 38.6244 51.5916 39.2649 52.9352C39.8743 53.3414 40.5304 54.6226 41.3898 53.982L43.6708 51.4197C43.8739 50.7791 43.4365 50.1854 42.749 50.3417Z",
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7478 50.3417C43.4352 50.1854 43.8727 50.7791 43.6696 51.4197L41.3885 53.982C40.5292 54.6226 39.873 53.3258 39.2637 52.9352C38.6231 51.5916 40.1386 51.2166 40.8573 52.279C41.2479 51.9041 42.2947 50.451 42.7478 50.3417Z",
    fill: "#004276"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_84_3626",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_84_3626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_84_3626",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthgoal);
export default __webpack_public_path__ + "static/media/health goal.5bd295cc6e1e21a5d88905f4574c303b.svg";
export { ForwardRef as ReactComponent };